import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Form, Modal, Button } from 'react-bootstrap';
import { FaPlus, FaCheck, FaEdit, FaTrash, FaSortAmountUp, FaChartLine, FaSortAmountDown, FaBell, FaArrowRight, FaArrowLeft, FaPaperPlane, FaUserCheck, FaChalkboardTeacher } from 'react-icons/fa';
import Navbar from '../../dashboard/navbar';
import Sidebar from '../../dashboard/sidebar';
import useAuth from '../../dashboard/useAuth';
import 'react-quill/dist/quill.snow.css';
import 'react-quill/dist/quill.bubble.css';
import axios from 'axios';
import { getAuthToken } from '../../../authToken';
import SummernoteEditor from '../qcm/summernote';

const Liste_situation = ({ titre }) => {
    useAuth();
    const [situation, setSituation] = useState([]);
    const [selectedSituation, setSelectedSituation] = useState(null);
    const [sortConfig, setSortConfig] = useState({ key: 'id', direction: 'ascending' });
    const [searchTerm, setSearchTerm] = useState('');
    const [showAddModal, setShowAddModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [nouvSituation, setNouvSituation] = useState({
        titre: '',
        description: '',
        titre_en: '',
        description_en: '',
        statut: '',
    });
    const [modifSituation, setModifSituation] = useState({
        titre: '',
        description: '',
        titre_en: '',
        description_en: '',
        statut: '',
    });
    const [isLoading, setIsLoading] = useState(false);

    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [alert, setAlert] = useState({ message: '', type: '' });

    // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const totalItems = situation.length;

    const location = useLocation();
    const user_id = localStorage.getItem('user_id');
    const navigate = useNavigate();

    // Utilisation de useEffect pour mettre à jour le titre de la page
    useEffect(() => {
        if (user_id) {
            document.title = "eTrainApp | Mises en situation";
        }
    }, [user_id]);

    const fetchSituation = async () => {
        setIsLoading(true);
        try {
            const token = localStorage.getItem('access_token');

            const response = await fetch(`${process.env.REACT_APP_HOTE}/liste-situation/`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });
            if (response.ok) {
                setIsLoading(false);
                const data = await response.json();
                setSituation(data);
            } else {
                setIsLoading(false);
                const data = await response.json();
                console.error('Erreur lors de la récupération des mises en situation', data);
            }
        } catch (error) {
            setIsLoading(false);
            console.error('Erreur réseau:', error);
        }
    };

    useEffect(() => {
        fetchSituation();
    }, []);

    // Handle alerts
    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        setTimeout(() => {
            setAlert({ message: '', type: '' });
        }, 3000);
    };

    const handleRowClick = (situation) => {
        setSelectedSituation(situation);
    };

    // Filter formations by search term
    const filteredSituation = situation.filter(situation =>
        situation.titre.toLowerCase().includes(searchTerm.toLowerCase()) ||
        situation.titre_en.toLowerCase().includes(searchTerm.toLowerCase()) ||
        situation.statut.toLowerCase().includes(searchTerm.toLowerCase())
    );

    // Sort Situations
    const sortedSituation = [...filteredSituation].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
            return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
            return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
    });

    const handleSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    // Pagination logic
    const indexOfLastSituation = currentPage * itemsPerPage;
    const indexOfFirstSituation = indexOfLastSituation - itemsPerPage;
    const currentSituation = sortedSituation.slice(indexOfFirstSituation, indexOfLastSituation);
    const totalPages = Math.ceil(sortedSituation.length / itemsPerPage);

    // Handle items per page change
    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1);
    };

    // Handle show delete modal
    const handleShowDeleteModal = () => setShowDeleteModal(true);
    const handleCloseDeleteModal = () => setShowDeleteModal(false);

    const handleShowEditModal = () => setShowEditModal(true);
    const handleCloseEditModal = () => setShowEditModal(false);

    const handleShowAddModal = () => setShowAddModal(true);
    const handleCloseAddModal = () => setShowAddModal(false);

    const handleEnregSituation = async () => {
        try {
            const token = localStorage.getItem('access_token');

            const response = await fetch(process.env.REACT_APP_HOTE + `/ajouter-situation/${user_id}/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(nouvSituation),
            });

            if (response.ok) {
                const result = await response.json();
                console.log('Mise en situation ajoutée avec succès:', result);
                handleCloseAddModal();
                fetchSituation();
                showAlert("Mise en situation ajoutée avec succès !");
            } else {
                const errorData = await response.json();
                console.error('Erreur du serveur:', errorData);
                showAlert('Erreur lors de l\'ajout de la mise en situation : ' + (errorData.message || 'Erreur inconnue.'));
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
            showAlert('Erreur de connexion au serveur. Veuillez réessayer plus tard.');
        }
    };

    useEffect(() => {
        const fetchSituationModif = async () => {
            if (!selectedSituation) {
                console.error('Aucune mise en situation sélectionnée');
                return;
            }

            try {
                const token = localStorage.getItem('access_token');

                const response = await fetch(`${process.env.REACT_APP_HOTE}/situation-info/${selectedSituation.id}/`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                });
                if (!response.ok) {
                    throw new Error('Erreur lors de la récupération de la mise en situation.');
                }
                const data = await response.json();

                setModifSituation({
                    titre: data.titre || '',
                    description: data.description || '',
                    titre_en: data.titre_en || '',
                    description_en: data.description_en || '',
                    statut: data.statut || '',
                });
                console.log('Données récupérées :', data);
            } catch (error) {
                console.error('Erreur lors de la récupération des données de la mise en situation :', error);
            } finally {
                setIsLoading(false);
            }
        };

        if (selectedSituation) {
            fetchSituationModif();
        }
    }, [selectedSituation]);

    const handleModifierSituation = async (event) => {
        event.preventDefault();
        try {
            const token = localStorage.getItem('access_token');

            const response = await fetch(process.env.REACT_APP_HOTE + `/modifier-situation/${selectedSituation.id}/${user_id}/`, {
                method: "PUT",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(modifSituation),
            });
            if (response.ok) {
                handleCloseEditModal();
                fetchSituation();
                showAlert("Mise en situation modifiée avec succès !");
            } else {
                alert("Erreur lors de la modification de la mise en situation.");
            }
        } catch (error) {
            console.error("Erreur réseau :", error);
        }
    };

    const handleDeleteSituation = async () => {
        if (selectedSituation) {
            try {
                const token = localStorage.getItem('access_token');

                const response = await fetch(process.env.REACT_APP_HOTE + `/supprimer-situation/${selectedSituation.id}/${user_id}/`, {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                });

                if (response.ok) {
                    setShowDeleteModal(false);
                    fetchSituation();
                    showAlert("Mise en situation supprimée avec succès !");
                } else {
                    console.error('Erreur lors de la suppression de la mise en situation');
                }
            } catch (error) {
                console.error('Erreur réseau:', error);
            }
        }
    };

    const [accesGroupe, setAccesGroupe] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupe(JSON.parse(accesGroupeStored));
        } else {
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupe(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                // console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    if (!accesGroupe.includes("AdminEtudeDeCas")) {
        return (
            <div id="wrapper">
                <Sidebar user_id={user_id} />
                <div id="page-wrapper" className="gray-bg">
                    <Navbar />
                    <div className="wrapper wrapper-content animated fadeInRight">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content text-center p-5">
                                        <div className="mb-4">
                                            <i className="fa fa-lock fa-5x text-warning"></i>
                                        </div>
                                        <h2>Accès restreint</h2>
                                        <p className="lead mb-4">
                                            Vous n'avez pas les autorisations nécessaires pour accéder à cette page.
                                        </p>
                                        <div className="d-flex justify-content-center">
                                            <Link to="/" className="btn btn-primary">
                                                <i className="fa fa-arrow-left mr-2"></i>
                                                Retour
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} titre={titre} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className='d-flex align-items-center'><FaChalkboardTeacher size={25} className='mr-2' />Gestion des mises en situation</h2>
                            <small>Administration des mises en situation.</small>

                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/admin`}> Administration</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Liste-situation`}> Mises en situation</Link>
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>
                    <div className="mt-3">
                        <div className="wrapper wrapper-content animated fadeInRight">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h5>Liste des mises en situation</h5>
                                <div>
                                    <Link onClick={handleShowAddModal} className="btn btn-success ms-2 mr-2 mt-1">
                                        <FaPlus /> Ajouter
                                    </Link>
                                    <button
                                        onClick={() => handleShowEditModal(selectedSituation)}
                                        className={`btn ms-2 mr-2 mt-1 ${selectedSituation ? 'btn-success' : 'btn-default text-dark'}`}
                                        disabled={!selectedSituation}
                                    >
                                        <FaEdit /> Modifier
                                    </button>
                                    <button
                                        onClick={handleShowDeleteModal}
                                        className={`btn ms-2 mr-2 mt-1 ${selectedSituation ? 'btn-success' : 'btn-default text-dark'}`}
                                        disabled={!selectedSituation}
                                    >
                                        <FaTrash /> Supprimer
                                    </button>
                                </div>
                            </div>

                            {alert.message && (
                                <div className={`alert alert-${alert.type}`}>
                                    {alert.message}
                                </div>
                            )}

                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="ibox">
                                        <div className="ibox-content">
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <div className="me-2">
                                                    <select
                                                        value={itemsPerPage}
                                                        onChange={handleItemsPerPageChange}
                                                        className="form-select bg-default p-1"
                                                        style={{ width: 'auto', border: '1px black solid', borderRadius: '5px' }}
                                                    >
                                                        <option value={10}>10</option>
                                                        <option value={20}>20</option>
                                                        <option value={50}>50</option>
                                                    </select>
                                                </div>
                                                <input
                                                    type="text"
                                                    placeholder="Rechercher..."
                                                    className="form-control"
                                                    style={{ maxWidth: '150px', width: '100%' }}
                                                    value={searchTerm}
                                                    onChange={(e) => setSearchTerm(e.target.value)}
                                                />
                                            </div>
                                            <div className="table-responsive" style={{ fontSize: '11px' }}>
                                                <table className="footable table table-stripped footable-loaded tablet breakpoint" data-page-size="8" data-filter="#filter">
                                                    <thead>
                                                        <tr>
                                                            <th className='text-secondary text-wrap d-none d-md-table-cell' style={{ minWidth: '150px' }} onClick={() => handleSort('titre')}>
                                                                Titre (FR) {sortConfig.key === 'titre'}{(sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                            </th>
                                                            <th className='text-secondary text-wrap d-none d-md-table-cell' style={{ minWidth: '150px' }} onClick={() => handleSort('titre_en')}>
                                                                Titre (EN) {sortConfig.key === 'titre_en'}{(sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                            </th>
                                                            <th className='text-secondary text-wrap d-none d-md-table-cell' style={{ minWidth: '100px' }} onClick={() => handleSort('statut')}>
                                                                Statut {sortConfig.key === 'statut'}{(sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                            </th>
                                                        </tr>
                                                    </thead>

                                                    {!isLoading ? (
                                                        <tbody>
                                                            {currentSituation.length > 0 ? currentSituation.map((situation) => (
                                                                <tr
                                                                    key={situation.id}
                                                                    className={`bg-white ${selectedSituation && selectedSituation.id === situation.id ? 'bg-success text-white' : ''}`}
                                                                    onClick={() => handleRowClick(situation)}
                                                                >
                                                                    <td>
                                                                        {situation.titre}
                                                                        <div className='lesInfos'>
                                                                            <small>Statut : {situation.statut}</small><br />
                                                                            <small>Titre EN : {situation.titre_en || 'Non défini'}</small>
                                                                        </div>
                                                                    </td>
                                                                    <td className="d-none d-md-table-cell">{situation.titre_en || 'Non défini'}</td>
                                                                    <td className="d-none d-md-table-cell">{situation.statut}</td>
                                                                </tr>
                                                            )) : (
                                                                <tr>
                                                                    <td colSpan="3" className="text-center">Aucune mise en situation disponible</td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    ) : (
                                                        <tbody>
                                                            <tr>
                                                                <td colSpan="8" className="text-center p-5">
                                                                    <div className="d-flex justify-content-center align-items-center">
                                                                        <div className="spiner-example">
                                                                            <div className="sk-spinner sk-spinner-wave">
                                                                                <div className="sk-rect1 mr-1"></div>
                                                                                <div className="sk-rect2 mr-1"></div>
                                                                                <div className="sk-rect3 mr-1"></div>
                                                                                <div className="sk-rect4 mr-1"></div>
                                                                                <div className="sk-rect5"></div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    )}
                                                </table>
                                            </div>
                                            <div className="d-flex justify-content-between align-items-center mt-3">
                                                <div className="dataTables_info" role="status" aria-live="polite">
                                                    {totalItems === 0
                                                        ? "Aucun élément à afficher"
                                                        : `Élément ${indexOfFirstSituation + 1} à ${Math.min(indexOfLastSituation, totalItems)} sur ${totalItems}`}
                                                </div>
                                                <div>
                                                    <button
                                                        onClick={() => setCurrentPage(currentPage > 1 ? currentPage - 1 : 1)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === 1}
                                                    >
                                                        <FaArrowLeft />
                                                    </button>

                                                    {(() => {
                                                        const pagesToShow = 5;
                                                        let startPage = Math.max(1, currentPage - Math.floor(pagesToShow / 2));
                                                        let endPage = Math.min(totalPages, startPage + pagesToShow - 1);

                                                        if (endPage - startPage < pagesToShow - 1) {
                                                            startPage = Math.max(1, endPage - pagesToShow + 1);
                                                        }

                                                        const pageButtons = [];

                                                        for (let i = startPage; i <= endPage; i++) {
                                                            pageButtons.push(
                                                                <button
                                                                    key={i}
                                                                    onClick={() => setCurrentPage(i)}
                                                                    className={`btn ${currentPage === i ? 'btn-default' : 'btn-light'} mx-1`}
                                                                >
                                                                    {i}
                                                                </button>
                                                            );
                                                        }

                                                        return pageButtons;
                                                    })()}

                                                    <button
                                                        onClick={() => setCurrentPage(currentPage < totalPages ? currentPage + 1 : totalPages)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === totalPages}
                                                    >
                                                        <FaArrowRight />
                                                    </button>

                                                    <button
                                                        onClick={() => setCurrentPage(totalPages)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === totalPages}
                                                    >
                                                        {totalPages}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Modal d'ajout - Version française et anglaise côte à côte */}
                    <Modal show={showAddModal} onHide={handleCloseAddModal} size="xl">
                        <Modal.Header>
                            <Modal.Title>Ajouter une mise en situation</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Form>
                                <div className="row">
                                    {/* Colonne Française */}
                                    <div className="col-md-6 border-right">
                                        <h6 className="text-primary mb-3"><strong>Version Française</strong></h6>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Titre (FR)</Form.Label>
                                            <Form.Control
                                                type="text"
                                                required
                                                value={nouvSituation.titre}
                                                onChange={(event) => {
                                                    setNouvSituation({
                                                        ...nouvSituation,
                                                        titre: event.target.value,
                                                    });
                                                }}
                                            />
                                        </Form.Group>

                                        <Form.Group className="mb-3">
                                            <Form.Label>Description (FR)</Form.Label>
                                            <SummernoteEditor 
                                                value={nouvSituation.description} 
                                                onChange={(value) => {
                                                    setNouvSituation({
                                                        ...nouvSituation,
                                                        description: value,
                                                    });
                                                }} 
                                            />
                                        </Form.Group>
                                    </div>

                                    {/* Colonne Anglaise */}
                                    <div className="col-md-6">
                                        <h6 className="text-success mb-3"><strong>Version Anglaise</strong></h6>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Titre (EN)</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={nouvSituation.titre_en}
                                                onChange={(event) => {
                                                    setNouvSituation({
                                                        ...nouvSituation,
                                                        titre_en: event.target.value,
                                                    });
                                                }}
                                            />
                                        </Form.Group>

                                        <Form.Group className="mb-3">
                                            <Form.Label>Description (EN)</Form.Label>
                                            <SummernoteEditor 
                                                value={nouvSituation.description_en} 
                                                onChange={(value) => {
                                                    setNouvSituation({
                                                        ...nouvSituation,
                                                        description_en: value,
                                                    });
                                                }} 
                                            />
                                        </Form.Group>
                                    </div>
                                </div>

                                {/* Champs communs en bas */}
                                <div className="row mt-3">
                                    <div className="col">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Statut</Form.Label>
                                            <Form.Control
                                                as="select"
                                                required
                                                value={nouvSituation.statut}
                                                onChange={(event) => {
                                                    setNouvSituation({
                                                        ...nouvSituation,
                                                        statut: event.target.value,
                                                    });
                                                }}
                                            >
                                                <option value="">Sélectionnez un statut</option>
                                                <option value="Brouillon">Brouillon</option>
                                                <option value="Publié">Publié</option>
                                            </Form.Control>
                                        </Form.Group>
                                    </div>
                                </div>

                                <div className="d-flex justify-content-end mt-4">
                                    <Button
                                        variant="secondary"
                                        className="me-2 mr-2"
                                        onClick={handleCloseAddModal}
                                    >
                                        Annuler
                                    </Button>
                                    <Button
                                        variant="success"
                                        className="me-2 mr-2"
                                        onClick={() => handleEnregSituation()}
                                    >
                                        Enregistrer
                                    </Button>
                                </div>
                            </Form>
                        </Modal.Body>
                    </Modal>

                    {/* Modal de modification - Version française et anglaise côte à côte */}
                    <Modal show={showEditModal} onHide={handleCloseEditModal} size="xl">
                        <Modal.Header>
                            <Modal.Title>Modifier la mise en situation</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Form onSubmit={handleModifierSituation}>
                                <div className="row">
                                    {/* Colonne Française */}
                                    <div className="col-md-6 border-right">
                                        <h6 className="text-primary mb-3"><strong>Version Française</strong></h6>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Titre (FR)</Form.Label>
                                            <Form.Control
                                                type="text"
                                                required
                                                value={modifSituation.titre}
                                                onChange={(event) => {
                                                    setModifSituation({
                                                        ...modifSituation,
                                                        titre: event.target.value,
                                                    });
                                                }}
                                            />
                                        </Form.Group>

                                        <Form.Group className="mb-3">
                                            <Form.Label>Description (FR)</Form.Label>
                                            <SummernoteEditor 
                                                value={modifSituation.description} 
                                                onChange={(value) => {
                                                    setModifSituation({
                                                        ...modifSituation,
                                                        description: value,
                                                    });
                                                }} 
                                            />
                                        </Form.Group>
                                    </div>

                                    {/* Colonne Anglaise */}
                                    <div className="col-md-6">
                                        <h6 className="text-success mb-3"><strong>Version Anglaise</strong></h6>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Titre (EN)</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={modifSituation.titre_en}
                                                onChange={(event) => {
                                                    setModifSituation({
                                                        ...modifSituation,
                                                        titre_en: event.target.value,
                                                    });
                                                }}
                                            />
                                        </Form.Group>

                                        <Form.Group className="mb-3">
                                            <Form.Label>Description (EN)</Form.Label>
                                            <SummernoteEditor 
                                                value={modifSituation.description_en} 
                                                onChange={(value) => {
                                                    setModifSituation({
                                                        ...modifSituation,
                                                        description_en: value,
                                                    });
                                                }} 
                                            />
                                        </Form.Group>
                                    </div>
                                </div>

                                {/* Champs communs en bas */}
                                <div className="row mt-3">
                                    <div className="col">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Statut</Form.Label>
                                            <Form.Control
                                                as="select"
                                                name="statut"
                                                value={modifSituation.statut}
                                                onChange={(e) =>
                                                    setModifSituation({
                                                        ...modifSituation,
                                                        statut: e.target.value,
                                                    })
                                                }
                                                required
                                            >
                                                <option value="">Sélectionnez un statut</option>
                                                <option value="Brouillon">Brouillon</option>
                                                <option value="Publié">Publié</option>
                                            </Form.Control>
                                        </Form.Group>
                                    </div>
                                </div>

                                <div className="d-flex justify-content-end mt-4">
                                    <Button
                                        variant="secondary"
                                        className="me-2 mr-2"
                                        onClick={handleCloseEditModal}
                                    >
                                        Annuler
                                    </Button>
                                    <Button
                                        variant="success"
                                        type="submit"
                                    >
                                        {isLoading ? (
                                            <span
                                                className="spinner-border spinner-border-sm"
                                                role="status"
                                                aria-hidden="true"
                                            ></span>
                                        ) : (
                                            <>
                                                Enregistrer
                                            </>
                                        )}
                                    </Button>
                                </div>
                            </Form>
                        </Modal.Body>
                    </Modal>

                    {/* Modal de suppression */}
                    <Modal show={showDeleteModal} onHide={handleCloseDeleteModal}>
                        <Modal.Header>
                            <Modal.Title>Confirmer la suppression</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            Êtes-vous sûr de vouloir supprimer la mise en situation : {selectedSituation && selectedSituation.titre} ?
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleCloseDeleteModal}>
                                Annuler
                            </Button>
                            <Button variant="success" onClick={handleDeleteSituation}>
                                Supprimer
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </div>
            </div>
        </div>
    );
};

export default Liste_situation;